// extracted by mini-css-extract-plugin
export var cardIcon = "_7s-4";
export var checkboxCard = "_7s-0";
export var checkboxCardSelected = "_7s-3";
export var disabled = "_7s-1";
export var outerBorder = "_7s-2";
export var spacerMedium = "_7s-7";
export var spacerSmall = "_7s-6";
export var spacerXsmall = "_7s-5";